// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuLayoutContainer{outline:none;display:inline-block}[data-dragging=true]{z-index:100;position:absolute!important}.vuuSimpleDraggableWrapper{background-color:#fff;box-shadow:0 6px 10px #0003}.vuuSimpleDraggableWrapper>*{width:100%;height:100%}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
